import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import type { ConversationStarter } from '@core/tellent-assistant-types';
import { DividerComponent, HeadingComponent, IconComponent } from '@core/user-interface-legacy';

import { TellentAssistantBrandMarkComponent } from '../brand-mark/tellent-assistant-brand-mark.component';

@Component({
  selector: 'tellent-assistant-empty-state',
  imports: [
    DividerComponent,
    HeadingComponent,
    IconComponent,
    TellentAssistantBrandMarkComponent,
    TranslatePipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (loading()) {
      <div class="skeleton"></div>
    } @else {
      <header class="intro">
        <tellent-assistant-brand-mark class="brand" [size]="32" />
        <rt-heading variant="heading large lighter" class="greeting">
          {{ 'tlc.tellent_assistant.empty_state.greeting' | translate: { name: userName() } }}
        </rt-heading>
        <rt-heading variant="heading large-x">
          {{ 'tlc.tellent_assistant.empty_state.heading' | translate }}
        </rt-heading>
      </header>
      <ul class="suggestions">
        @for (suggestion of suggestions(); track suggestion.id) {
          @if (!$first) {
            <div class="divider-wrap">
              <rt-divider />
            </div>
          }
          <li class="suggestion" (click)="suggestionClick.emit(suggestion)">
            <span class="label">{{ suggestion.text }}</span>
            <rt-icon
              name="keyboard-arrow-right"
              colorToken="colorIconAiStrongDefault"
              class="chevron"
            />
          </li>
        }
      </ul>
    }
  `,
  styleUrl: './tellent-assistant-empty-state.component.less',
  host: {
    '[class.expanded]': 'expanded()',
  },
})
export class TellentAssistantEmptyStateComponent {
  public readonly userName = input.required<string>();
  public readonly suggestions = input.required<readonly ConversationStarter[]>();
  public readonly loading = input<boolean>(false);
  public readonly expanded = input.required<boolean>();
  public readonly suggestionClick = output<ConversationStarter>();
}
